import MultipleChoicePoll from '@polleverywhere/core/lib/models/multiple_choice_poll'
import FreeTextPoll from '@polleverywhere/core/lib/models/free_text_poll'

export default function createActivityFromParams (params) {
  let model
  if (params.has('answers')) {
    model = new MultipleChoicePoll({
      activity_type: 'multiple-choice',
      title: params.get('poll_title') || 'Untitled',
      options: params.getAll('answers').map(x => { return { value: x, results_count: 0 } })
    })
  } else {
    model = new FreeTextPoll({
      title: params.get('poll_title') || 'Untitled'
    })
  }

  return model
}
